// extracted by mini-css-extract-plugin
module.exports = {"text":"EmailAlreadyExistStyle_text__2GfnT","title":"EmailAlreadyExistStyle_title__ivums"};